import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-20"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"font-size":"24px"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"font-size":"24px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.giftCodeManage')
  }, {
    default: _withCtx(() => [
      (_ctx.hasMasterAdminPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = () => (_ctx.isShowCreateNewTypesModal = true))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_PlusCircleOutlined)
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('text.createNewGiftCodeType')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_table, {
        dataSource: _ctx.typesDataSource,
        columns: _ctx.typesColumns,
        pagination: false,
        loading: _ctx.isLoadingTypes,
        expandedRowKeys: _ctx.expandedRowKeys,
        "onUpdate:expandedRowKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedRowKeys) = $event)),
        "row-key": (record) => record.id,
        scroll: {x: '100%'}
      }, {
        bodyCell: _withCtx(({ column, record, text }) => [
          (column.dataIndex === 'keygen')
            ? (_openBlock(), _createElementBlock("pre", _hoisted_2, _toDisplayString(text), 1))
            : (column.key === 'action')
              ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                  default: _withCtx(() => [
                    (_ctx.hasMasterAdminPermission)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          danger: "",
                          onClick: ($event: any) => (_ctx.deleteTypeConfirm(record))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_DeleteOutlined)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
        ]),
        expandedRowRender: _withCtx(({ record }) => [
          (record.keygen.indexOf('.') !== -1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_a_form, {
                  name: `formGift-${record.id}`,
                  onSubmit: () => _ctx.onFinishGift(record),
                  scrollToFirstError: true,
                  layout: "inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.giftcode_type_name'),
                      required: true,
                      hidden: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: record.id,
                          readonly: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('text.num'),
                      required: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: record.num,
                          "onUpdate:value": ($event: any) => ((record.num) = $event),
                          min: 1,
                          max: 20
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          loading: record.isLoadingGift,
                          disabled: !record.num
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.create')), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "disabled"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["name", "onSubmit"]),
                (record.createdGifts?.length)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      type: "success",
                      class: "mt-20"
                    }, {
                      description: _withCtx(() => [
                        _createVNode(_component_a_typography_paragraph, { copyable: "" }, {
                          copyableIcon: _withCtx(({ copied }) => [
                            _createElementVNode("div", _hoisted_4, [
                              (!copied)
                                ? (_openBlock(), _createBlock(_component_CopyOutlined, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_CheckOutlined, { key: 1 }))
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("pre", null, _toDisplayString('Xin gửi tặng bạn ' + record.createdGifts?.length + ' mã GiftCode ['+record.name+']:' + '\n' + record.createdGifts?.join('\n') + '\n' + 'Chúc bạn chơi game vui vẻ!'), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_a_alert, { type: "success" }, {
                  description: _withCtx(() => [
                    _createVNode(_component_a_typography_paragraph, { copyable: "" }, {
                      copyableIcon: _withCtx(({ copied }) => [
                        _createElementVNode("div", _hoisted_6, [
                          (!copied)
                            ? (_openBlock(), _createBlock(_component_CopyOutlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_CheckOutlined, { key: 1 }))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("pre", null, _toDisplayString('Xin gửi tặng bạn GiftCode ['+record.name+']:' + '\n' + record.keygen + '\n' + 'Chúc bạn chơi game vui vẻ!'), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "loading", "expandedRowKeys", "row-key"]),
      (_ctx.hasMasterAdminPermission)
        ? (_openBlock(), _createBlock(_component_a_modal, {
            key: 1,
            open: _ctx.isShowCreateNewTypesModal,
            onCancel: _cache[4] || (_cache[4] = () => (_ctx.isShowCreateNewTypesModal = false)),
            title: _ctx.$t('text.createNewGiftCodeType'),
            footer: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "formType",
                model: _ctx.formModelType,
                onFinish: _ctx.onFinishType,
                rules: _ctx.formRuleType,
                scrollToFirstError: true,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.giftcode_type_name'),
                    name: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formModelType.name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModelType.name) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.giftcode_type_keygen') + ' (' +_ctx.$t('message.giftCodeTypeKeygenHelp')+ ')',
                    name: "keygen"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formModelType.keygen,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModelType.keygen) = $event)),
                        placeholder: "Ke...yGen....XyZ.."
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        block: "",
                        loading: _ctx.isSavingType
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish", "rules"])
            ]),
            _: 1
          }, 8, ["open", "title"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}